import { AgreementQuery } from '@libs/api-reference';
import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';

import * as API from '../requests';
import { USER_QUERY_KEYS } from '../constants';

export default function useUserAgreements() {
  const {
    execute: getUserAgreement,
    isPending: isLoadingAgreements,
    result,
    ...query
  } = useQueryV2<AgreementQuery>(API.getUserAgreements, {
    key: USER_QUERY_KEYS.agreements,
  });

  const userAgreements = computed(() => result.value?.data || []);

  return {
    getUserAgreement,
    userAgreements,
    isLoadingAgreements,
    ...query,
  };
}
